import { NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { QuickActionCardComponent, QuickActionCardModel } from '..';

@Component({
	selector: 'sb-quick-action-list',
	standalone: true,
	imports: [MatCardModule, QuickActionCardComponent, NgFor],
	template: `
		<mat-card class="quick-action-list-container">
			<mat-card-header>
				<mat-card-title><b>{{ caption }}</b></mat-card-title>
			</mat-card-header>
			<mat-card-content class="quick-action-list-content">
				<sb-quick-action-card *ngFor="let card of cards; let i = index"
					[model]="card"
					[colorIndex]="i"
				></sb-quick-action-card>
			</mat-card-content>
		</mat-card>
	`,
	styleUrl: './quick-action-list.component.less',
})
export class QuickActionListComponent {
	/** The text to display above the list of quick action cards */
	@Input() caption = 'What would you like to do?';
	@Input() cards: QuickActionCardModel[];
}
